/**
 * Keeps the consent checkboxes usable with Dawn's ajax cart:
 * - the footer's consent markup is re-rendered when the cart changes, so ticked boxes are restored
 * - the checkout button stays disabled until all required consents are ticked
 */
class CartConsents extends HTMLElement {
  constructor() {
    super();
    this.checked = new Set();
    this.addEventListener('change', (event) => {
      const input = event.target;
      if (input.type !== 'checkbox') return;
      input.checked ? this.checked.add(input.name) : this.checked.delete(input.name);
      this.updateCheckout();
    });
    new MutationObserver(() => this.restore()).observe(this, { childList: true, subtree: true });
  }

  connectedCallback() {
    this.updateCheckout();
    // Guard against bypassing the disabled button (e.g. Enter key in the cart form).
    this.form?.addEventListener('submit', (event) => {
      if (!this.allRequiredChecked()) {
        event.preventDefault();
        this.querySelector('input[data-consent-required]:not(:checked)')?.focus();
      }
    });
  }

  get form() {
    return document.getElementById(this.dataset.form);
  }

  restore() {
    this.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.checked = this.checked.has(input.name);
    });
    this.updateCheckout();
  }

  allRequiredChecked() {
    return [...this.querySelectorAll('input[data-consent-required]')].every((input) => input.checked);
  }

  updateCheckout() {
    const button = document.getElementById('checkout');
    if (!button) return;
    const cartEmpty = document.getElementById('main-cart-footer')?.classList.contains('is-empty');
    button.disabled = Boolean(cartEmpty) || !this.allRequiredChecked();
  }
}

customElements.define('cart-consents', CartConsents);
